import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

import AccountLogsComponent from 'webapp/components/account/logs/index';
import AccountLogsLockedScreenComponent from 'webapp/components/account/logs/locked-screen';

export default class SettingsLogsRouteTemplate extends Component {
	@service('billing') declare billingService: Service.Billing;

	get isActivityLogEnabled() {
		return this.billingService.checkIfCan(BillingFeature.ACTIVITY_LOG);
	}

	<template>
		{{#if this.isActivityLogEnabled}}
			<AccountLogsComponent />
		{{else}}
			<AccountLogsLockedScreenComponent />
		{{/if}}
	</template>
}
